"use client";
import * as React from "react";
const SvgCoffeeOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12.89 0H1.78C.8 0 0 .8 0 1.78v5.07c0 3.4 2.62 6.39 6.03 6.48a6.23 6.23 0 0 0 6.41-6.22v-.89h.45A3.1 3.1 0 0 0 16 3.12 3.1 3.1 0 0 0 12.89 0m-2.22 1.78v2.66h-8.9V1.78zm0 4.44v.9a4.45 4.45 0 0 1-4.45 4.44A4.45 4.45 0 0 1 1.78 7.1v-.89zm2.22-1.78h-.45V1.78h.45a1.33 1.33 0 1 1 0 2.66M0 14.22h14.22V16H0z" }));
export {
  SvgCoffeeOutlined as default
};
